import React, { createContext, useContext, useState, ReactNode } from 'react';
import { Option } from '@/interfaces';

interface SubSidebarState {
	title: string | ReactNode;
	sections: Option[];
	onlyMobile?: boolean;
}

interface LayoutContextType {
	subSidebar: SubSidebarState | null;
	setSubSidebar: (state: SubSidebarState | null) => void;
}

const LayoutContext = createContext<LayoutContextType | undefined>(undefined);

export const LayoutProvider: React.FC<{ children: ReactNode }> = ({
	children,
}) => {
	const [subSidebar, setSubSidebar] = useState<SubSidebarState | null>(null);

	return (
		<LayoutContext.Provider value={{ subSidebar, setSubSidebar }}>
			{children}
		</LayoutContext.Provider>
	);
};

export const useLayout = () => {
	const context = useContext(LayoutContext);
	if (context === undefined) {
		throw new Error('useLayout must be used within a LayoutProvider');
	}
	return context;
};
